import React from 'react';

import { Link } from 'react-router-dom';
import "../prob-s.css"

function SexualBehaviorPage(props) {
    return (
        <div className='Form-Page More-Forms-Page Sexual-Behavior-Page'>
            <main>
                <header>
                    <span className='Page-Back'><Link to={"/"}>{"←"}</Link></span>
                    <h3>Professional Services for People with Problematic Sexual Behaviors or Sexual Interests</h3>
                </header>
                <div className='Form-Group'>
                    <p>The Sexual Behavior Program at Behavioral Health Solutions provides evaluation and treatment for people with a wide range of problematic sexual behaviors and sexual interests.</p> 

                    <p>We provide treatment for people struggling with a variety of sexual behavior problems, such as excessive pornography use, sexual abuse of children, sexual assault of adults, voyeurism (peeping), exhibitionism (exposing), and possession or use of child sexual abuse materials (child pornography).  We also provide treatment for people experiencing unwanted and/or problematic sexual interests, such as sexual interests in minors and sexual fetishes.</p>  

                    <p>Some of our clients have been court-ordered to receive sex offender treatment.  Others have been referred by another professional or an agency, such as Department of Social Services.  Other clients are concerned about their sexual behavior, thoughts, or feelings and contact us directly.  Services are available for children (ages 11 and older), adolescents, and adults.   We approach our clients’ needs with respect, professionalism, and high ethical standards.</p>
                </div>
                <div className="Form-Group">
                    <h5>Treatment</h5>
                    <p>Treatment begins with a clinical assessment of the client’s treatment needs, leading to an individualized treatment plan.  Treatment follows current best practices and incorporates cognitive-behavioral psychotherapy, relapse prevention, and Good Lives.  Treatment is provided in individual, group, and/or family psychotherapy sessions. </p>
                </div>
                <div className="Form-Group">
                    <h5>Evaluation</h5>
                    <p>Keith Hersh conducts psychosexual/sex offender specific evaluations of adults.  Jane Hollings conducts these evaluations for adolescents and children ages 11 and up.    Evaluation methods and conclusions are guided by current research on people with sexual behavior problems.  Evaluations are conducted at the request of mental health professionals, attorneys, Social Service agencies, and other referral sources.   When necessary, court testimony may be given about evaluation results. </p>
                    <p>We also provide training and consultation on a variety of subjects related to evaluation, treatment, and management of those with sexual behavior problems.</p>

 

                </div>
            </main>
        </div>
    );
}

export default SexualBehaviorPage;